import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"
import SelectedFiltersInFacet from "./elements/SelectedFiltersInFacet"
import { isMobile } from "../helpers"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    const facetRef = useRef(null);
    useEffect(() => {
        if(window.innerWidth > 719) {
            const handleClickOutside = (event) => {
              if (facetRef.current && !facetRef.current.contains(event.target)) {
                if (active) {
                    setActive(!active)
                }
              }
            };
        
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
              document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [active, setActive]);

    function removeFiltersOfRangeFacet() {
        if(!isSelected) return;
        updateRange([min, max]);
    }

    return (
        <li class={`ns-sidebar-dropdown ns-range-facet ${active ? "ns-active" : ""}`} ref={facetRef}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-color-black ns-font-4">{facet.name}</span>
                {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center">
                        {1}
                    </span>
                )}
                {/* <Icon name="arrow" className="ns-absolute" /> */}
                {isMobile ? (
                    <span class="icon icon-new icon-chevron ">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"></path></svg>
                    </span>
                ) : (
                <span class="icon icon-new icon-chevron-small ">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2.75"></path></svg>
                </span>
                )}
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-absolute ns-background-white">
                <SelectedFiltersInFacet isRangeFacet={true} maxValue={max} layout={"desktop"} filtersOfFacet={isSelected} removeFilters={removeFiltersOfRangeFacet} />
                <div class="ns-price-range-wrapper">
                    <div class="ns-d-flex ns-justify-content-between ns-font-4 filter-drawer__price-range-input-wrapper">
                        <div class="ns-range-input-container">
                            {/* <label for={`ns-${facet.id}-min`} class="ns-form-label">
                                Min.
                            </label> */}
                            <span class="filter-drawer__price-range-currency">£</span>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <span class="filter-drawer__price-range-separator">–</span>
                        <div class="ns-range-input-container">
                            {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
                                Max.
                            </label> */}
                            <span class="filter-drawer__price-range-currency">£</span>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider id={facet.id} />
                </div>
                <SelectedFiltersInFacet isRangeFacet={true} maxValue={max} layout={"mobile"} filtersOfFacet={isSelected}/>
            </div>
        </li>
    )
}
